module.exports = __webpack_public_path__ + "img/brand3.f2674dba.png";